import { render, staticRenderFns } from "./GpTabContent.vue?vue&type=template&id=3a91c5f3&scoped=true&"
import script from "./GpTabContent.vue?vue&type=script&lang=js&"
export * from "./GpTabContent.vue?vue&type=script&lang=js&"
import style0 from "./GpTabContent.vue?vue&type=style&index=0&id=3a91c5f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91c5f3",
  null
  
)

export default component.exports